<template>
  <div class="confirm-email-wrapper">
    <h1 class="registration-page-title">Account Registered!</h1>
    <div class="form">
      <p>Your account has successfully been created. Click below to Login to your account.</p>
      <button @click="redirectionToLoginPage">Continue To Login</button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import authService from "@/services/authService";
import { tryParseApiErrors } from "@/utils";

const loading = ref(false);
const success = ref(true);
const failure = ref(false);
const route = useRoute();
const router = useRouter();
const errors = ref([]);

onMounted(async () => {
  try {
    await authService.confirmEmail(route.params.user_id, route.params.token);
    success.value = true;
  } catch (error) {
    errors.value = tryParseApiErrors(error);
    failure.value = true;
  }
  loading.value = false;
});

function redirectionToLoginPage() {
  router.push({ name: "login" });
}
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "../styles/pages/_authorisation-forms.scss";

.confirm-email-wrapper {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  padding: 32px 0 48px;
  text-align: center;
  font-family: $lh_font_family_dm_sans;
}

.registration-page-title {
  font-family: $lh_font_family_dm_sans;
  font-size: 32px;
  font-weight: 700;
  color: $lh_color_navy;
  margin-bottom: 24px;
}

.form {
  p {
    color: $lh_color_blue_gray;
    margin-bottom: 24px;
  }

  button {
    width: 100%;
    padding: 14px 16px;
    border: none;
    border-radius: 8px;
    background: $lh_color_navy;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    font-family: $lh_font_family_dm_sans;
    cursor: pointer;

    &:hover {
      background: $lh_color_navy_dark;
    }
  }
}

@media (max-width: 600px) {
  .confirm-email-wrapper {
    padding: 24px 0 40px;
  }

  .registration-page-title {
    font-size: 26px;
  }
}
</style>
